<template>
<div class="field">
    <div v-show="false"><!-- Hide tippy initially -->
        <div ref="picker" class="gradient-picker">
            <div
                v-for="rule in defaultGradients"
                @click="onSelectRule(rule)"
                :style="{ background: rule }"
                :class="{
                    'is-selected': rule === gradientStringToStyleObj.background
                }"
                :key="rule"/>
        </div>
    </div>
    <label class="label">Title Gradient</label>
    <p class="help">
        <span>
            <a :href="premadeGradientsUrl" target="_blank">More gradients</a>,
            or
            <a :href="gradientToolUrl" target="_blank">create a gradient</a>.
        </span>
    </p>
    <div class="control">
        <div class="field has-addons">
            <div class="control" ref="tippyRef">
                <a :style="gradientStringToStyleObj" class="button">
                    <FaIcon icon="ellipsis-v"/>
                </a>
            </div>
            <div class="control is-expanded">
                <input
                    v-bind="$attrs"
                    v-on="inputListeners"
                    :value="value"
                    class="input"/>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import tippy from '@/tippy'
import { gradientStringToStyleObj } from '@/utils'
import gradients from './gradients'

export default {
    name: 'GradientInput',
    inheritAttrs: false,
    props: {
        value: String, // A css 'background' property.
    },
    data: () => ({
        gradientToolUrl: 'https://cssgradient.io/',
        premadeGradientsUrl: 'https://gradienthunt.com/',
        demoUrl: 'https://youtu.be/vf6c2w86WB4',
        defaultGradients: gradients,
    }),
    computed: {
        gradientStringToStyleObj: vm => gradientStringToStyleObj(vm.value),
        inputListeners: vm => ({
            ...vm.$listeners,
            // for transparent v-model with the parent component
            input: event => vm.$emit('input', event.target.value)
        }),
    },
    // TODO: DRY this up with Theme.vue
    mounted () {
        const { tippyRef, picker } = this.$refs
        const pickerTheme = 'light-border'
        const tippyInstance = tippy(tippyRef, {
            content: ref => picker,
            interactive: true,
            appendTo: this.$el,
            //trigger: 'click', // DEBUG ONLY
            placement: 'top-start',
            theme: pickerTheme,
            // Dark theme on color picker looks bad. Stay on light theme.
            onAfterUpdate (instance, partialProps) {
                const { theme } = partialProps
                if (theme && theme !== pickerTheme) {
                    instance.setProps({ theme: pickerTheme })
                }
            }
        })

        this.$once('hook:destroyed', tippyInstance.destroy)
    },
    methods: {
        onSelectRule (rule) {
            // Need to re-add the property key, since i only scraped the values
            // from gradienthunt.com
            const backgroundProp = `background: ${rule}`
            this.$emit('input', backgroundProp)
        }
    }
}
</script>

<style lang="scss" scoped>
// 10x10 grid
.gradient-picker {
    display: grid;
    grid-gap: 2px;
    grid-template-columns: repeat(auto-fill, 30px);
    grid-template-rows: repeat(auto-fill, 20px);
    width: 320px;
    height: 220px;
    div {
        cursor: pointer;
        position: relative;
        &.is-selected, &:hover {
            z-index: 1;
            outline: 3px solid #333;
        }
    }
}
</style>
